export const ITEM_UNIT_ON_ORDER = () => ({
  type: 'item',
  attributes: {
    orderId: '',
    quantity: 1,
    clientId: ''
  }
})
